import React from "react";

function LoaderDots(){
    return (
        <div className="loader-dots">
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default LoaderDots